import styled from 'styled-components';

export const Container = styled.div`
  .tasks-table th {
    font-weight: 600;
    color: ${(props) => props.theme.$gray700};
    border-top: 0;
    white-space: nowrap;
  }

  .tasks-table td {
    vertical-align: middle;
  }

  .tasks-row {
    cursor: pointer;
  }

  .tasks-row:hover,
  .tasks-row:focus {
    background: ${(props) => props.theme.$gray100};
    outline: 0;
  }

  .tasks-bidding {
    max-width: 320px;
  }

  .task-count {
    padding: 0 6px;
    color: ${(props) => props.theme.$gray700};
  }

  .material-icons {
    font-size: 16px;
  }

  @media print {
    .table-responsive {
      overflow: visible;
    }

    .tasks-bidding {
      max-width: none;
    }

    .tasks-bidding .text-truncate {
      overflow: visible;
      white-space: normal;
    }

    .badge {
      padding: 0;
      background: none !important;
      color: ${(props) => props.theme.$gray900} !important;
      font-size: inherit;
    }
  }
`;
